




























































import Vue from "vue";
import AppTableRow from "@/components/table/AppTableRow.vue";
import { EventBus } from "@/eventbus";
import AdminStatusTag from "./AdminStatusTag.vue";
export default Vue.extend({
  components: {
    AppTableRow,
    AdminStatusTag,
  },
  props: ["source", "common_row_data"],
  setup(props) {
    const onAction = () => {
      EventBus.emit("change-status", props.source);
    };
    const showMenu = (event: MouseEvent) => {
      EventBus.emit("showMenu", { user: props.source, event });
    };
    return {
      onAction,
      showMenu,
    };
  },
});
